import React from "react";

import UsageSkeleton from "@/components/usage/UsageSkeleton";
import UsageStatBandSkeleton from "@/components/usage/UsageStatBandSkeleton";

// One tenant's usage report, before it loads: the headline band, then the two
// cards under it, in the heights the real cards take.
const TenantUsageSkeleton = () => (
  <div className="flex flex-col gap-4">
    <UsageStatBandSkeleton />
    <UsageSkeleton className="h-64 w-full" />
    <UsageSkeleton className="h-40 w-full" />
  </div>
);

export default TenantUsageSkeleton;
